import tinymce from "./tinymce";
import naja from "naja";
import {Modal} from "bootstrap";
import sortable from "html5sortable/src/html5sortable";

export default function(html) {
	const form = html.querySelector('form#frm-pageManager-pageForm')
	if (form) {
		const ajaxStartCallback = (event) => {
			const url = new URL(event.detail.request.url)
			const params = new URLSearchParams(url.search)

			if (event.detail.request.method !== 'GET' || params.get('ajaxLoader')?.toString() === "true") {
				html.querySelector('#ajaxLoader')?.classList.remove('d-none')
			}

			html.querySelectorAll('.modal').forEach((el) => {
				if (!el.dataset.ajaxHideSkip) {
					Modal.getInstance(el)?.hide();
				}
			})
		}

		const snippetBeforeUpdateCallback = () => {
			html.querySelectorAll('.tinymce-initiated').forEach((el) => {
				const editor = window.tinymce.get(el.getAttribute('id'))
				editor.remove()
			})
		}

		const snippetAfterUpdateCallback = () => {
			html.querySelector('#ajaxLoader')?.classList.add('d-none')
		}

		const redirectHandler = (event) => {
			if (!event.detail.url.includes('editorMode=') || event.detail.url.includes('forceRedirect=1')) {
				event.detail.setHardRedirect(true)
			}
		}

		naja.removeEventListener('start', ajaxStartCallback)
		naja.addEventListener('start', ajaxStartCallback)

		naja.snippetHandler.removeEventListener('beforeUpdate', snippetBeforeUpdateCallback)
		naja.snippetHandler.addEventListener('beforeUpdate', snippetBeforeUpdateCallback)

		naja.snippetHandler.removeEventListener('afterUpdate', snippetAfterUpdateCallback)
		naja.snippetHandler.addEventListener('afterUpdate', snippetAfterUpdateCallback)

		naja.redirectHandler.removeEventListener('redirect', redirectHandler)
		naja.redirectHandler.addEventListener('redirect', redirectHandler)


		const showPageType = (value) => {
			const dynamic = form.querySelector('.row.dynamic').closest('.container')
			const people = form.querySelector('.row.people').closest('.container')
			const otherPageType = form.querySelector('.row.other-page-type').closest('.container')

			dynamic.classList.add('d-none')
			people.classList.add('d-none')
			otherPageType.classList.add('d-none')

			form.querySelectorAll('.other-page-type-topic').forEach((el) => {
				el.classList.add('d-none')
			})

			if (value === 'dynamic') {
				dynamic.classList.remove('d-none')

			} else if (value === 'people') {
				people.classList.remove('d-none')
				form.querySelectorAll('.other-page-type-topic[data-page-type-people]').forEach((el) => {
					el.classList.remove('d-none')
				})

			} else if (value === 'news') {
				otherPageType.classList.remove('d-none')
				form.querySelectorAll('.other-page-type-topic[data-page-type-news]').forEach((el) => {
					el.classList.remove('d-none')
				})

			} else if (value === 'official_desk') {
				otherPageType.classList.remove('d-none')
				form.querySelectorAll('.other-page-type-topic[data-page-type-official_desk]').forEach((el) => {
					el.classList.remove('d-none')
				})

			} else if (value === 'documents') {
				otherPageType.classList.remove('d-none')
				form.querySelectorAll('.other-page-type-topic[data-page-type-documents]').forEach((el) => {
					el.classList.remove('d-none')
				})
			}
		}

		tinymce({
			selector: 'textarea[data-tinymce]:not(.tinymce-initiated)',
			height: 360,
		})

		form.querySelectorAll('input[type=radio][name=type]').forEach((el) => {
			el.addEventListener('change', (e) => {
				showPageType(e.currentTarget.value)
			})
		})

		form.querySelectorAll('.modal.topics .topic').forEach((topic) => {
			topic.classList.add('d-none')
		})

		form.querySelectorAll('input[type=radio][name=type]').forEach((el) => {
			el.addEventListener('change', (e) => {
				form.querySelectorAll('.modal.topics .topic').forEach((topic) => {
					topic.classList.add('d-none')
				})

				form.querySelectorAll('.modal.topics [data-page-type-' + e.currentTarget.value + ']').forEach((topic) => {
					topic.classList.remove('d-none')
				})
			})
		})

		const type = form.querySelector('input[type=radio][name=type]:checked')
		if (type) {
			showPageType(type.value)

			form.querySelectorAll('.modal.topics [data-page-type-' + type.value + ']').forEach((topic) => {
				topic.classList.remove('d-none')
			})
		}

		for (let selector of ['#topic1Modal', '#topic2Modal']) {
			const btn = html.querySelector('button[data-bs-target="' + selector + '"]')

			html.querySelectorAll(selector + ' input[type=radio]').forEach((el) => {
				el.addEventListener('change', (e) => {
					btn.classList.add('placeholder')
					btn.classList.remove('btn')
					btn.classList.remove('btn-outline-blue')
					btn.classList.remove('text-uppercase')
					btn.textContent = btn.dataset.text

					const el = e.target
					if (el.checked) {
						btn.classList.remove('placeholder')
						btn.classList.add('btn')
						btn.classList.add('btn-outline-blue')
						btn.classList.add('text-uppercase')
						btn.textContent = el.nextElementSibling.textContent
					}
				})
			})

			html.querySelector(selector + ' button.reset').addEventListener('click', (e) => {
				e.preventDefault()

				e.currentTarget.closest('.modal').querySelectorAll('input[type=radio]').forEach((el) => {
					el.checked = false

					btn.classList.add('placeholder')
					btn.classList.remove('btn')
					btn.classList.remove('btn-outline-blue')
					btn.classList.remove('text-uppercase')
					btn.textContent = btn.dataset.text
				})
			})
		}

		form.querySelectorAll('input[type=radio][name=section]').forEach((el) => {
			el.addEventListener('change', (e) => {
				form.querySelectorAll('.modal.departments .department').forEach((department) => {
					department.classList.add('d-none')
				})

				const values = e.currentTarget.value === 'both' ? ['web', 'intranet'] : [e.currentTarget.value]
				for (let value of values) {
					form.querySelectorAll('.modal.departments [data-' + value + ']').forEach((department) => {
						department.classList.remove('d-none')
					})
				}
			})
		})

		const section = form.querySelector('input[type=radio][name=section]:checked')
		if (section) {
			const values = section.value === 'both' ? ['web', 'intranet'] : [section.value]
			for (let value of values) {
				form.querySelectorAll('.modal.departments [data-' + value + ']').forEach((department) => {
					department.classList.remove('d-none')
				})
			}
		}

		form.querySelectorAll('button.upload-more').forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault()
				if (e.isTrusted) {
					e.currentTarget.closest('.widget').querySelector('.drop-zone').click()
				}
			})
		})

		form.querySelectorAll('.upload-helper, .upload-more').forEach((el) => {
			const input = el.querySelector('input[type=file]')
			if (input) {
				input.addEventListener('change', (e) => {
					const multiple = e.currentTarget.hasAttribute('multiple')
					let row = el.classList.contains('upload-more')
						? e.currentTarget.closest('.upload-more').previousElementSibling.previousElementSibling
						: e.currentTarget.closest('.upload-helper').nextElementSibling
					let widgetFiles = e.currentTarget.closest('.widget.files')

					row.querySelectorAll('.img-preview.not-uploaded, .file-preview.not-uploaded').forEach((el) => {
						el.remove()
					})

					for (const file of e.target.files) {
						if (!widgetFiles && file.type.startsWith("image/")) {
							const col = document.createElement("div")
							const remove = document.createElement("button")
							const img = document.createElement("img")

							col.classList.add('img-preview')
							col.classList.add('not-uploaded')
							if (multiple) {
								col.classList.add('multiple')
							}

							remove.setAttribute('type', 'button')
							remove.classList.add('remove')

							remove.innerHTML = '<i class="fas fa-times"></i>'
							remove.addEventListener('click', (e) => {
								row.querySelectorAll('.img-preview.not-uploaded, .file-preview.not-uploaded').forEach((el) => {
									el.remove()
								})

								input.value = null

								if (row.querySelectorAll('.img-preview, .file-preview').length === 0) {
									el.classList.remove('d-none')
									el.parentElement.querySelector('.upload-more')?.classList.add('d-none')
								}
							})

							img.file = file
							img.classList.add('img-fluid')
							if (multiple) {
								img.setAttribute('style', 'max-height: 120px')
							}

							col.appendChild(remove)
							col.appendChild(img)
							row.appendChild(col)

							el.parentElement.querySelector('.upload-more')?.classList.remove('d-none')

							const reader = new FileReader()
							reader.onload = () => {
								if (typeof reader.result === 'string') {
									img.src = reader.result
								}
							}
							reader.readAsDataURL(file)

						} else {
							const col = document.createElement("div")
							const text = document.createElement("div")
							const remove = document.createElement("button")

							col.classList.add('file-preview')
							col.classList.add('not-uploaded')
							if (multiple) {
								col.classList.add('multiple')
							}

							remove.setAttribute('type', 'button')
							remove.classList.add('remove')

							remove.innerHTML = '<i class="fas fa-times"></i>'
							remove.addEventListener('click', (e) => {
								row.querySelectorAll('.img-preview.not-uploaded, .file-preview.not-uploaded').forEach((el) => {
									el.remove()
								})

								input.value = null

								if (row.querySelectorAll('.img-preview, .file-preview').length === 0) {
									el.classList.remove('d-none')
									el.parentElement.querySelector('.upload-more')?.classList.add('d-none')
								}
							})

							text.classList.add('file')
							text.classList.add('text-nowrap')
							text.innerHTML = '<i class="fas fa-file me-2"></i>' + file.name

							col.appendChild(remove)
							col.appendChild(text)
							row.appendChild(col)

							el.parentElement.querySelector('.upload-more')?.classList.remove('d-none')
						}
					}

					if (!el.classList.contains('upload-more')) {
						el.classList.add('d-none')
					}
				})

				const dropZone = el.querySelector('.drop-zone')
				if (dropZone) {
					dropZone.addEventListener('dragover', (e) => {
						e.preventDefault()

						dropZone.classList.remove('btn-outline-blue')
						dropZone.classList.add('btn-blue')
					})

					dropZone.addEventListener('dragleave', (e) => {
						e.preventDefault()

						dropZone.classList.remove('btn-blue')
						dropZone.classList.add('btn-outline-blue')
					})

					dropZone.addEventListener('drop', (e) => {
						e.preventDefault()

						dropZone.classList.remove('btn-blue')
						dropZone.classList.add('btn-outline-blue')

						input.files = e.dataTransfer.files
						input.dispatchEvent(new Event('change'))
					})
				}

				el.addEventListener('click', (e) => {
					const input = el.querySelector('input[type=file]')
					if (input) {
						input.click()
					}
				})
			}
		})

		html.querySelectorAll('input[name=section]').forEach((el) => {
			el.addEventListener('change', (e) => {
				const web = html.querySelector('input[name=parentWeb]').closest('.web')
				const intranet = html.querySelector('input[name=parentIntranet]').closest('.intranet')
				const value = e.currentTarget.value

				if (web && intranet) {
					const webText = web.querySelector('.form-text')
					const intranetText = intranet.querySelector('.form-text')

					web.classList.add('d-none')
					webText.classList.add('d-none')
					intranet.classList.add('d-none')
					intranetText.classList.add('d-none')

					if (value === 'web') {
						web.classList.remove('d-none')

					} else if (value === 'intranet') {
						intranet.classList.remove('d-none')

					} else if (value === 'both') {
						web.classList.remove('d-none')
						webText.classList.remove('d-none')
						intranet.classList.remove('d-none')
						intranetText.classList.remove('d-none')
					}
				}
			})
		})

		html.querySelectorAll('.img-preview button.remove, .file-preview button.remove').forEach((el) => {
			el.addEventListener('click', (e) => {
				const root = e.currentTarget.closest('.d-flex')
				const stack = root.nextElementSibling
				stack.value += e.currentTarget.dataset.id + ';'

				e.currentTarget.closest('.img-preview')?.remove()
				e.currentTarget.closest('.file-preview')?.remove()

				if (root.querySelectorAll('.img-preview, .file-preview').length === 0) {
					root.previousElementSibling.classList.remove('d-none')
					root.parentElement.querySelector('.upload-more')?.classList.add('d-none')
				}
			})
		})

		for (let section of ['web', 'intranet']) {
			const selector = '[data-bs-toggle=modal][data-' + section + '-url]'
			html.querySelectorAll(selector).forEach((el) => {
				el.addEventListener('click', (e) => {
					const loader = document.querySelector('#contentPreviewLoader')
					loader.classList.remove('d-none')

					const iframe = document.querySelector('#contentPreviewModal iframe.' + section)
					iframe.classList.add('d-none')

					const url = e.currentTarget.getAttribute('data-' + section + '-url')
					if (url) {
						const callback = (e) => {
							loader.classList.add('d-none')
							e.currentTarget.classList.remove('d-none')
						}

						iframe.removeEventListener('load', callback)
						iframe.addEventListener('load', callback)

						iframe.setAttribute('src', url)

					} else {
						alert('URL not found.')
					}
				})
			})
		}

		form.querySelectorAll('input[type=checkbox][name="departments[]"]').forEach((el) => {
			el.addEventListener('change', (e) => {
				const value = e.currentTarget.value

				const box = form.querySelector('.departments-box')
				const list = form.querySelector('.departments-list')

				if (el.checked) {
					box.classList.add('d-none')
					list.querySelector('[data-code="' + value + '"]')?.classList.remove('d-none')

				} else {
					list.querySelector('[data-code="' + value + '"]')?.classList.add('d-none')

					if (form.querySelectorAll('input[type=checkbox][name="departments[]"]:checked').length === 0) {
						box.classList.remove('d-none')
					}
				}
			})
		})


		initWidgetArticles(html)
		initWidgetInfobox(html)
		initWidgetContacts(html)
		initWidgetPeople(html)
		initDynamicPageSortable(html)
		initWidgetFilesSortable(html)
	}
}


function initWidgetArticles(html) {
	html.querySelectorAll('.widget.articles').forEach((widget) => {
		// Source callback
		const sourceCallback = (value) => {
			const departments = widget.querySelectorAll('.row.departments')
			const topics = widget.querySelectorAll('.row.topics')
			const author = widget.querySelectorAll('.row.author')

			departments.forEach((el) => {
				el.classList.add('d-none')
			})

			topics.forEach((el) => {
				el.classList.add('d-none')
			})

			author.forEach((el) => {
				el.classList.add('d-none')
			})

			if (value === 'department') {
				departments.forEach((el) => {
					el.classList.remove('d-none')
				})
			} else if (value === 'topic') {
				topics.forEach((el) => {
					el.classList.remove('d-none')
				})
			} else if (value === 'author') {
				author.forEach((el) => {
					el.classList.remove('d-none')
				})
			}
		}
		
		// Selection callback
		const selectionCallback = (value) => {
			const auto = widget.querySelectorAll('.row.auto')
			const manually = widget.querySelectorAll('.row.manually')

			auto.forEach((el) => {
				el.classList.add('d-none')
			})

			manually.forEach((el) => {
				el.classList.add('d-none')
			})

			if (value === 'auto') {
				auto.forEach((el) => {
					el.classList.remove('d-none')
				})

				sourceCallback(null)
				widget.querySelectorAll('input[name*="Source"]:checked').forEach((el) => {
					sourceCallback(el.value)
				})

			} else if (value === 'manually') {
				manually.forEach((el) => {
					el.classList.remove('d-none')
				})
			}
		}


		widget.querySelectorAll('input[name*="Selection"]').forEach((el) => {
			el.addEventListener('change', (e) => {
				selectionCallback(e.currentTarget.value)
			})
		})

		widget.querySelectorAll('input[name*="Selection"]:checked').forEach((el) => {
			selectionCallback(el.value)
		})


		widget.querySelectorAll('input[name*="Source"]').forEach((el) => {
			el.addEventListener('change', (e) => {
				sourceCallback(e.currentTarget.value)
			})
		})

		widget.querySelectorAll('input[name*="Source"]:checked').forEach((el) => {
			sourceCallback(el.value)
		})

		widget.querySelectorAll('.typeahead input[name*="ArticleId"]').forEach((el) => {
			el.addEventListener('complete', (e) => {
				const typeahead = e.target.previousElementSibling
				const user = typeahead.value
				const userId = parseInt(e.target.value)

				if (!userId) {
					return
				}

				const name = typeahead.getAttribute('name').replace(/Article]/, 'Articles][]')

				const check = document.createElement('div')
				check.classList.add('form-check')

				const input = document.createElement('input')
				input.setAttribute('type', 'checkbox')
				input.setAttribute('name', name)
				input.setAttribute('id', name + 'user' + userId)
				input.classList.add('form-check-input')
				input.value = userId.toString()
				input.checked = true

				const label = document.createElement('label')
				label.setAttribute('for', name + 'user' + userId)
				label.classList.add('form-check-label')
				label.textContent = user

				check.append(input)
				check.append(label)

				const articles = typeahead.closest('.row.articles')
					.nextElementSibling.querySelector('.col-9')

				articles.append(check)

				e.target.value = ''
				typeahead.value = ''
			})
		})
	})
}


function initWidgetInfobox(html) {
	html.querySelectorAll('.widget.infobox').forEach((widget) => {
		// Contact callback
		const contactCallback = (row, value) => {
			const departments = widget.querySelectorAll('.row.departments[data-part="' + row.dataset.part + '"]')
			const persons = widget.querySelectorAll('.row.persons[data-part="' + row.dataset.part + '"]')

			departments.forEach((el) => {
				el.classList.add('d-none')
			})

			persons.forEach((el) => {
				el.classList.add('d-none')
			})

			if (value === 'department') {
				departments.forEach((el) => {
					el.classList.remove('d-none')
				})
			} else if (value === 'people') {
				persons.forEach((el) => {
					el.classList.remove('d-none')
				})
			}
		}

		// Information callback
		const informationCallback = (row, value) => {
			const text = widget.querySelectorAll('.row.text[data-part="' + row.dataset.part + '"]')
			const contact = widget.querySelectorAll('.row.contact[data-part="' + row.dataset.part + '"]')

			text.forEach((el) => {
				el.classList.add('d-none')
			})

			contact.forEach((el) => {
				el.classList.add('d-none')
			})

			if (value === 'text') {
				text.forEach((el) => {
					tinymce({
						selector: 'textarea[data-tinymce-text][data-part-' + row.dataset.part + ']',
						height: 360,
					})
					el.classList.remove('d-none')
				})
			} else {
				contact.forEach((el) => {
					el.classList.remove('d-none')
				})

				contactCallback(row, null)
				row.querySelectorAll('input[name*="Contact"]:checked').forEach((el) => {
					contactCallback(row, el.value)
				})
			}
		}


		widget.querySelectorAll('input[name*="Information"]').forEach((el) => {
			el.addEventListener('change', (e) => {
				const row = e.currentTarget.closest('.row')
				informationCallback(row, e.currentTarget.value)
			})
		})

		widget.querySelectorAll('input[name*="Information"]:checked').forEach((el) => {
			const row = el.closest('.row')
			informationCallback(row, el.value)
		})


		widget.querySelectorAll('input[name*="Contact"]').forEach((el) => {
			el.addEventListener('change', (e) => {
				const row = e.currentTarget.closest('.row')
				contactCallback(row, e.currentTarget.value)
			})
		})

		widget.querySelectorAll('input[name*="Contact"]:checked').forEach((el) => {
			const row = el.closest('.row')
			contactCallback(row, el.value)
		})


		// Persons
		widget.querySelectorAll('.typeahead input[name*="PersonId"]').forEach((el) => {
			el.addEventListener('complete', (e) => {
				const typeahead = e.target.previousElementSibling
				const user = typeahead.value
				const userId = parseInt(e.target.value)

				if (!userId) {
					return
				}

				const name = typeahead.getAttribute('name').replace(/Person]/, 'Persons][]')

				const check = document.createElement('div')
				check.classList.add('form-check')

				const input = document.createElement('input')
				input.setAttribute('type', 'checkbox')
				input.setAttribute('name', name)
				input.setAttribute('id', name + 'user' + userId)
				input.classList.add('form-check-input')
				input.value = userId.toString()
				input.checked = true

				const label = document.createElement('label')
				label.setAttribute('for', name + 'user' + userId)
				label.classList.add('form-check-label')
				label.textContent = user

				check.append(input)
				check.append(label)

				const persons = typeahead.closest('.row.persons')
					.nextElementSibling.querySelector('.col-9')

				persons.append(check)

				e.target.value = ''
				typeahead.value = ''
			})
		})

		widget.querySelectorAll('.infobox-next-part').forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault()
				const part = parseInt(el.dataset.part) + 1
				el.closest('.widget').querySelectorAll('.shown.infobox-part-' + part).forEach((el) => {
					el.classList.remove('d-none')
				})
				el.dataset.part = part.toString()
			})
		})
	})
}


function initWidgetContacts(html) {
	html.querySelectorAll('.widget.contacts').forEach((widget) => {
		const selectionCallback = (value) => {
			const departments = widget.querySelectorAll('.row.departments')
			const persons = widget.querySelectorAll('.row.persons')

			departments.forEach((el) => {
				el.classList.add('d-none')
			})

			persons.forEach((el) => {
				el.classList.add('d-none')
			})

			if (value === 'department') {
				departments.forEach((el) => {
					el.classList.remove('d-none')
				})
			} else {
				persons.forEach((el) => {
					el.classList.remove('d-none')
				})
			}
		}

		widget.querySelectorAll('input[name*="Selection"]').forEach((el) => {
			el.addEventListener('change', (e) => {
				selectionCallback(e.currentTarget.value)
			})
		})

		widget.querySelectorAll('input[name*="Selection"]:checked').forEach((el) => {
			selectionCallback(el.value)
		})


		widget.querySelectorAll('.typeahead input[name*="PersonId"]').forEach((el) => {
			el.addEventListener('complete', (e) => {
				const typeahead = e.target.previousElementSibling
				const user = typeahead.value
				const userId = parseInt(e.target.value)

				if (!userId) {
					return
				}

				const name = typeahead.getAttribute('name').replace(/Person]/, 'Persons][]')

				const check = document.createElement('div')
				check.classList.add('form-check')

				const input = document.createElement('input')
				input.setAttribute('type', 'checkbox')
				input.setAttribute('name', name)
				input.setAttribute('id', name + 'user' + userId)
				input.classList.add('form-check-input')
				input.value = userId.toString()
				input.checked = true

				const label = document.createElement('label')
				label.setAttribute('for', name + 'user' + userId)
				label.classList.add('form-check-label')
				label.textContent = user

				check.append(input)
				check.append(label)

				const persons = typeahead.closest('.row.persons')
					.nextElementSibling.querySelector('.col-9')

				persons.append(check)

				e.target.value = ''
				typeahead.value = ''
			})
		})
	})
}


function initWidgetPeople(html) {
	html.querySelectorAll('.widget.people').forEach((widget) => {
		const linkCallback = (row, value) => {
			const url = widget.querySelectorAll('.row.url[data-part="' + row.dataset.part + '"]')

			url.forEach((el) => {
				el.classList.add('d-none')
			})

			if (value === 'page') {
				url.forEach((el) => {
					el.classList.remove('d-none')
				})
			}
		}

		widget.querySelectorAll('input[name*="Link"]').forEach((el) => {
			el.addEventListener('change', (e) => {
				const row = e.currentTarget.closest('.row')
				linkCallback(row, e.currentTarget.value)
			})
		})

		widget.querySelectorAll('input[name*="Link"]:checked').forEach((el) => {
			const row = el.closest('.row')
			linkCallback(row, el.value)
		})

		widget.querySelectorAll('.people-next-part').forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault()
				const part = parseInt(el.dataset.part) + 1
				el.closest('.widget').querySelectorAll('.shown.people-part-' + part).forEach((el) => {
					el.classList.remove('d-none')
				})
				el.dataset.part = part.toString()
			})
		})
	})
}


function initDynamicPageSortable(html) {
	for (let el of sortable('.rows-sortable', {
		forcePlaceholderSize: false,
		placeholder: '<div class="sortable-placeholder"><div class="placeholder-area">' + html.querySelector('.row.dynamic').dataset.placeholderText + '</div></div>',
		handle: '.sortable-row-move'
	})) {
		el.addEventListener('sortstart', (e) => {
			const height = e.detail.item.offsetHeight
			const interval = setInterval(() => {
				const ph = e.detail.item.closest('.rows-sortable').querySelector('.sortable-placeholder')
				if (ph) {
					clearInterval(interval)
					ph.className += ' ' + e.detail.item.className
					ph.classList.remove('sortable-dragging')
					ph.querySelector('.placeholder-area').style.height = `${height}px`
					ph.style.height = height + 'px'
				}
			}, 10)
		})

		el.addEventListener('sortstop', (e) => {
			e.detail.item.querySelectorAll('.tinymce-initiated').forEach(input => {
				let editor = window.tinymce.get(input.getAttribute('id'))
				if (editor) {
					editor.save()
					window.tinymce.remove(editor)
					input.classList.remove('tinymce-initiated')

					tinymce({
						selector: 'textarea#' + input.getAttribute('id'),
						height: 360,
					})
				}
			})
		})

		el.addEventListener('sortupdate', (e) => {
			const originRowIndex = e.detail.item.dataset.rowIndex
			const newRowIndex = e.detail.destination.index

			const url = e.detail.item.closest('.rows-sortable').dataset.url
			naja.makeRequest('GET', url, {
				origin: originRowIndex,
				destination: newRowIndex,
				ajaxLoader: 'true'
			}, {history: false}).catch((err) => {
				alert(err)
			})
		})
	}

	for (let el of sortable('.cols-sortable', {
		forcePlaceholderSize: false,
		placeholder: '<div class="sortable-placeholder"><div class="placeholder-area">' + html.querySelector('.row.dynamic').dataset.placeholderText + '</div></div>',
		handle: '.sortable-col-move',
		orientation: "horizontal"
	})) {
		el.addEventListener('sortstart', (e) => {
			const height = e.detail.item.offsetHeight
			const interval = setInterval(() => {
				const ph = e.detail.item.closest('.cols-sortable').querySelector('.sortable-placeholder')
				if (ph) {
					clearInterval(interval)
					ph.className += ' ' + e.detail.item.className
					ph.classList.remove('sortable-dragging')
					ph.querySelector('.placeholder-area').style.height = `${height}px`
					ph.style.height = height + 'px'
				}
			}, 10)
		})

		el.addEventListener('sortstop', (e) => {
			e.detail.item.querySelectorAll('.tinymce-initiated').forEach(input => {
				let editor = window.tinymce.get(input.getAttribute('id'))
				if (editor) {
					editor.save()
					window.tinymce.remove(editor)
					input.classList.remove('tinymce-initiated')

					tinymce({
						selector: 'textarea#' + input.getAttribute('id'),
						height: 360,
					})
				}
			})
		})

		el.addEventListener('sortupdate', (e) => {
			const rowIndex = e.detail.item.dataset.rowIndex
			const originColIndex = e.detail.item.dataset.colIndex
			const newColIndex = e.detail.destination.index

			const url = e.detail.item.closest('.cols-sortable').dataset.url
			naja.makeRequest('GET', url, {
				rowIndex: rowIndex,
				origin: originColIndex,
				destination: newColIndex,
				ajaxLoader: 'true'
			}, {history: false}).catch((err) => {
				alert(err)
			})
		})
	}

	for (let el of sortable('.widgets-sortable', {
		forcePlaceholderSize: false,
		placeholder: '<div class="sortable-placeholder"><div class="placeholder-area">' + html.querySelector('.row.dynamic').dataset.placeholderText + '</div></div>',
		handle: '.sortable-widget-move',
		acceptFrom: '.widgets-sortable',
	})) {
		el.addEventListener('sortstart', (e) => {
			const height = e.detail.item.offsetHeight
			const interval = setInterval(() => {
				const ph = e.detail.item.closest('.widgets-sortable').querySelector('.sortable-placeholder')
				if (ph) {
					clearInterval(interval)
					ph.className += ' ' + e.detail.item.className
					ph.classList.remove('sortable-dragging')
					ph.querySelector('.placeholder-area').style.height = `${height}px`
					ph.style.height = height + 'px'
				}
			}, 10)
		})

		el.addEventListener('sortstop', (e) => {
			e.detail.item.querySelectorAll('.tinymce-initiated').forEach(input => {
				let editor = window.tinymce.get(input.getAttribute('id'))
				if (editor) {
					editor.save()
					window.tinymce.remove(editor)
					input.classList.remove('tinymce-initiated')

					tinymce({
						selector: 'textarea#' + input.getAttribute('id'),
						height: 360,
					})
				}
			})
		})

		el.addEventListener('sortupdate', (e) => {
			const rowIndex = e.detail.item.dataset.rowIndex
			const colIndex = e.detail.item.dataset.colIndex
			const originWidgetIndex = e.detail.item.dataset.widgetIndex
			const newWidgetIndex = e.detail.destination.index
			const newRowIndex = e.detail.destination.container.dataset.row
			const newColIndex = e.detail.destination.container.dataset.col

			const url = e.detail.item.closest('.widgets-sortable').dataset.url
			naja.makeRequest('GET', url, {
				rowIndex: rowIndex,
				colIndex: colIndex,
				origin: originWidgetIndex,
				destination: newWidgetIndex,
				newRowIndex: newRowIndex,
				newColIndex: newColIndex,
				ajaxLoader: 'true'
			}, {history: false}).catch((err) => {
				alert(err)
			})
		})
	}
}


function initWidgetFilesSortable(html) {
	for (let el of sortable('.widget-files-sortable', {
		forcePlaceholderSize: true,
		placeholderClass: 'sortable-file-placeholder',
		placeholder: '<div class="sortable-file-placeholder"><div class="file-placeholder-area">' + html.querySelector('.widget-files-sortable')?.dataset.placeholderText + '</div></div>',
		orientation: "horizontal"
	})) {
		el.addEventListener('sortupdate', (e) => {
			const pageColumnWidgetId = e.detail.item.dataset.pageColumnWidgetId
			const widgetName = e.detail.item.dataset.widgetName
			const fileId = e.detail.item.dataset.fileId
			const destination = e.detail.destination.index

			const url = e.detail.item.closest('.widget-files-sortable').dataset.url
			naja.makeRequest('GET', url, {
				pageColumnWidgetId: pageColumnWidgetId,
				widgetName: widgetName,
				fileId: fileId,
				destination: destination,
				ajaxLoader: 'true'
			}, {history: false}).catch((err) => {
				alert(err)
			})
		})
	}
}
